import type { EnumProps } from "@/components/EnumBadge.tsx";
import { Trans } from "@lingui/react/macro";
import type { MetalStatus } from "@warrenio/api-spec/spec.oats.gen";
import type { ReactNode } from "react";
import { entries } from "remeda";

interface MetalStatusInfo extends EnumProps {
    description: ReactNode;
}

export const statusDescriptions: Record<MetalStatus, MetalStatusInfo> = {
    available: {
        color: "success",
        label: <Trans>Available</Trans>,
        description: <Trans>Machine is available for immediate leasing by clients.</Trans>,
    },
    pending: {
        color: "warning",
        label: <Trans>Pending</Trans>,
        description: (
            <Trans>
                Machine is ordered by client, but does not satisfy the required configuration.
                <br />
                After it has been configured as needed, move to “in use” status.
            </Trans>
        ),
    },
    in_use: {
        color: "primary",
        label: <Trans>In use</Trans>,
        description: <Trans>Machine is being used by client and is being charged.</Trans>,
    },
    cleaning: {
        color: "default",
        label: <Trans>Cleaning</Trans>,
        description: <Trans>Machine requires disk cleaning operations.</Trans>,
    },
    offline: {
        color: "default",
        label: <Trans>Offline</Trans>,
        description: <Trans>Machine is unavailable or requires repairs.</Trans>,
    },
    deleted: { color: "error", label: <Trans>Deleted</Trans>, description: null },
};

export interface MetalStatusItem extends MetalStatusInfo {
    id: MetalStatus;
}

export const statusItems = entries(statusDescriptions).map(([id, obj]): MetalStatusItem => ({ id, ...obj }));
